import React from "react";
import { OperationsDashboard } from "../components/OperationsDashboard";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Revenue and Margin Detailed View",
  charts: [],
  filters: [],
  Component: () =>
    React.createElement(OperationsDashboard, { variant: "revenue_trend" }),
};
